import React, { useState} from "react";
import { Button, IconButton, Icon } from "./ui";
import WallEdit from "./WallEdit"
import CornerEdit from "./CornerEdit";
import RoomEdit from "./RoomEdit";
import WindowEdit from "./WindowEdit";



const EditBar = (props) => {

    const [totalFloors, setTotalFloors] = useState(props.floorNumber);

    const addFloor = () => {
        setTotalFloors(totalFloors + 1);
        props.addFloor();
    }

    const deleteFloor = () => {
        if (props.deleteCurrentFloor()) {
            setTotalFloors(totalFloors - 1)
        }
    }

    const renderSelected2DEntity = ()=>{
        if(props.selected2DEntity.isSelected){
            switch (props.selected2DEntity.type) {
                case "wall":
                    return <WallEdit floorplanningHelper={props.floorplanningHelper}
                                updateFloorplan={props.updateFloorplan}
                                resetSelected2DEntity={props.resetSelected2DEntity}/>;
                case "corner":
                    return <CornerEdit floorplanningHelper={props.floorplanningHelper}
                                resetSelected2DEntity={props.resetSelected2DEntity}/>;
                case "room":
                    return <RoomEdit floorplanningHelper={props.floorplanningHelper}/>
                default:
                    break;
            }
        }
    }

    const renderWindowSettings = ()=>{
        return props.showWindowSettings ?  <WindowEdit floorplanner = {props.floorplanner}/> : null;
    }

    const style = {
        height: '100%', /* Full-height: remove this if you want "auto" height */
        width: '200px', /* Set the width of the sidebar */
        position: 'fixed', /* Fixed Sidebar (stay in place on scroll) */
        zIndex: 1, /* Stay on top */
        top: 0, /* Stay at the top */
        right: 0,
        backgroundColor: '#FFFFFF', /* light gray */
        overflowX: 'hidden', /* Disable horizontal scroll */
        paddingTop: '20px',
        borderLeft: '2px solid #e0e0e0',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    }
    const contentStyle = {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '5px',
        padding: '0 10px',
    }
    const horizontalStyle = {
        display: "flex",
        alignItems: "stretch",
        justifyContent: "center",
        flexDirection : "row",
    }
    const verticalStyle = {
        alignSelf: "center",
    }
    return (
        <div style={style} >
                {/*
                <Button color='lightBlue' style={{width:"180px"}} onClick={addFloor}>Add floor</Button>
                <Select defaultValue={floorSelected} options={makeSelection(props.floorNumber)} onChange={props.setFloor}/>
                <div>
                    Total floors: {totalFloors}
                </div>
                <div>
                    Select floor:
                </div>
                <div style={horizontalStyle}>
                    <IconButton size='large' onClick={props.previousFloor}>
                        <Icon name="PrevArrowIcon" />
                    </IconButton>
                    <div style={verticalStyle}>
                        {props.floorSelected}
                    </div>
                    <IconButton size='large' onClick={props.nextFloor}>
                        <Icon name="NextArrowIcon" />
                    </IconButton>
                </div>
                */}
                
                {/* 
                <Button color='red' onClick={deleteFloor}>Delete current floor</Button>
                */}


                {/* 
                    When an item (door, window or floor item) is selected, the options for that item will be put here:
                */}
                {renderWindowSettings()}
                {renderSelected2DEntity()}
        </div>
    )
}

export default EditBar